import {
  MileagePackageCopyProps,
  PlanCopy,
  getMileagePackageCopy,
} from '../utils/get-mileage-package-copy';
import { useMemo } from 'react';
import { VehiclePlan } from '../types/vehicle';

export interface UseMileagePackageCopyProps
  extends Omit<MileagePackageCopyProps, 'plan'> {
  plans: VehiclePlan[] | undefined;
}

export default function useMileagePackageCopy({
  plans,
  ...rest
}: UseMileagePackageCopyProps): PlanCopy[] | undefined {
  const composedPlans = useMemo(() => {
    return plans?.map((plan) => {
      return getMileagePackageCopy({ plan, ...rest });
    });
  }, [plans, rest]);

  return composedPlans;
}
